import { Button } from "antd";
import styled from "styled-components";

export const ButtonIconCentered = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
